import { Button, Modal, Row } from "react-bootstrap";
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import { MyTextInput } from "../../../ui/controls/MyTextInput";
import { useDispatch, useSelector } from 'react-redux';
import { MyDatePicker } from "../../../ui/controls/MyDatePicker";
import { MySelect } from "../../../ui/controls/MySelect";
import { deletePassengerIndividualFile, editPassengerIndividualFile } from "../../../../store/slices/individualFiles/thunks";

export const EditPassenger = ({ passenger, isOpen, setIsOpen }) => {
  const dispatch = useDispatch();
  const { customersList } = useSelector((state) => state.general);

  const delete2 = () => {
    const success = () => {
      setIsOpen(false);
    }
    dispatch(deletePassengerIndividualFile(passenger.id, passenger.idIndividualFile, success));
  }

  return (
    <>
      <Modal
        size="xl"
        show={isOpen}
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header>
          <Modal.Title >
            Editar Pasajero
          </Modal.Title>
          <Button
            onClick={() => setIsOpen(false)}
            className="btn-close"
            variant=""
          >
            x
          </Button>
        </Modal.Header>

        <Formik
          initialValues={{
            customer: undefined,
            name: passenger.name,
            lastName: passenger.lastName,
            mothersLastName: passenger.mothersLastName,
            relationship: passenger.relationship,
            birthdate: passenger.birthdate,
          }}
          onSubmit={(({ name, lastName, mothersLastName, relationship, birthdate },
            { resetForm, setErrors }) => {

            let birthdate2;
            if (birthdate) {              
              if (birthdate.year) {
                birthdate2 = birthdate.year + "-" + (birthdate.monthIndex + 1) + "-" + birthdate.day
              } else {
                const temp = birthdate.split("-")
                birthdate2 = temp[2] + "-" + temp[1] + "-" + temp[0]
              }
            }


            const success = () => {
              resetForm();
              setIsOpen(false)
            }
            dispatch(editPassengerIndividualFile(passenger.id, name, lastName, mothersLastName, relationship,
              birthdate2 ? birthdate2 : undefined, passenger.idIndividualFile, success));

          })}
          validationSchema={
            Yup.object({
              name: Yup.string()
                .required("Requerido"),
              lastName: Yup.string()
                .required("Requerido"),
            })
          }
        >

          {
            ({ setFieldValue }) => (
              <Form>
                <Modal.Body>
                  <Row>
                    <div className="col-lg-6 col-md-12">
                      <div className=" row mb-4">
                        <MySelect label='Cliente:*' name="customer" options={customersList} mode='horizontal'
                          singleSelect="true"
                          onChange={e => {
                            setFieldValue("customer", e);
                          }} />
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-0"></div>
                    <div className="col-lg-6 col-md-12">
                      <div className=" row mb-4">
                        <MyTextInput label='Nombre(s):*' name='name' mode='horizontal' />
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-12">
                      <div className=" row mb-4">
                        <MyTextInput label='Apellido Paterno*:' name='lastName' mode='horizontal' />
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-12">
                      <div className=" row mb-4">
                        <MyTextInput label='Apellido Materno:' name='mothersLastName' mode='horizontal' />
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-12">
                      <div className=" row mb-4">
                        <MyTextInput label='Parentesco:' name='relationship' mode='horizontal' />
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-12">
                      <div className=" row mb-4">
                        <MyDatePicker
                          label='Fecha de nacimiento' name="birthdate" mode='horizontal'
                          className="form-control fc-datepicker"
                          singleSelect="true"
                          placeholder="dd/mm/aaaa"
                          onChange={e => {
                            setFieldValue("birthdate", e);
                          }} />
                      </div>
                    </div>
                  </Row>
                  <div style={{ fontSize: 13 }}>* Dato obligatorio</div>
                </Modal.Body>

                <Modal.Footer>
                  <div style={{ width: "100%" }}>
                    <Button variant="danger" type="button" style={{ float: "left" }} onClick={delete2}>
                      Eliminar
                    </Button>
                    <Button variant="primary" type="submit" style={{ float: "right" }}>
                      Guardar Informacion
                    </Button>
                  </div>
                </Modal.Footer>
              </Form>
            )
          }
        </Formik>


      </Modal>
    </>
  );
}
